import './polyfill';
import 'reflect-metadata';
import './assets/less/site.less';
import 'react-toastify/dist/ReactToastify.css';
import 'semantic-ui-less/semantic.less';
import '@planit/bryntum-scheduler/scheduler.stockholm.css';
import './styles/tailwind.css';

import { createBrowserHistory } from 'history';
import { Provider as InversifyProvider } from 'inversify-react';
import * as moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import configureStore from './configureStore';
import i18n from './i18n';
import { container, initialize as initializeInversify, setup } from './inversify.config';
import { routes as Routes } from './routes';
import * as serviceWorker from './serviceWorker';
import { getCurrentLng } from './utils/useful-functions';

moment.locale(getCurrentLng());

// avoid client caching. See: https://github.com/facebook/create-react-app/issues/1910
serviceWorker.unregister();

// Configure IoC Container
setup();

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;

const store = configureStore(history, initialState);

function renderApp() {
  // This code starts up the React app when it runs in a browser. It sets up the routing configuration
  // and injects the app into a DOM element.
  ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
      <ReduxProvider store={store}>
        <I18nextProvider i18n={i18n}>
          <InversifyProvider container={container}>
            <Routes />
          </InversifyProvider>
        </I18nextProvider>
      </ReduxProvider>
    </BrowserRouter>,
    document.getElementById('root')
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  // serviceWorker.unregister();
}

if (initialState) {
  initializeInversify(initialState);
  renderApp();
} else {
  initializeInversify(store.getState());
  renderApp();
}
